export enum COMPARISON_OPERATOR {
    EQUAL = 'equal',
    NOT_EQUAL = 'not_equal',
    GREATER_THAN = 'greater_than',
    GREATER_THAN_OR_EQUAL = 'greater_than_or_equal',
    LESS_THAN = 'less_than',
    LESS_THAN_OR_EQUAL = 'less_than_or_equal',
    IN = 'in',
    NOT_IN = 'not_in',
    LIKE = 'like',
    IS = 'is',
    IS_NOT = 'is_not'
}

export const COMPARISON_SYMBOL = {
    EQUAL:                 '=',
    NOT_EQUAL:             '!=',
    GREATER_THAN:          '>',
    GREATER_THAN_OR_EQUAL: '>=',
    LESS_THAN:             '<',
    LESS_THAN_OR_EQUAL:    '<=',
    IN:                    '=',
    NOT_IN:                '=',
    LIKE:                  'ILIKE',
    IS:                    'IS',
    IS_NOT:                'IS NOT'
} as const;

export enum SQL {
    SELECT = 'SELECT',
    FROM = 'FROM',
    WHERE = 'WHERE',
    GROUP_BY = 'GROUP BY',
    ORDER_BY_DIRECTION = 'ORDER BY',
    ASC = 'ASC',
    DESC = 'DESC',
    WILDCARD = '*',
    // ClickHouse-specific
    PREWHERE = 'PREWHERE',
    HAVING = 'HAVING',
    FINAL = 'FINAL',
    SETTINGS = 'SETTINGS'
}

export const COMPARISON_OPERATOR_TO_SYMBOL : {
    [operator in COMPARISON_OPERATOR] : string
} = {
    [ COMPARISON_OPERATOR.EQUAL ]:                 COMPARISON_SYMBOL.EQUAL,
    [ COMPARISON_OPERATOR.NOT_EQUAL ]:             COMPARISON_SYMBOL.NOT_EQUAL,
    [ COMPARISON_OPERATOR.GREATER_THAN ]:          COMPARISON_SYMBOL.GREATER_THAN,
    [ COMPARISON_OPERATOR.GREATER_THAN_OR_EQUAL ]: COMPARISON_SYMBOL.GREATER_THAN_OR_EQUAL,
    [ COMPARISON_OPERATOR.LESS_THAN ]:             COMPARISON_SYMBOL.LESS_THAN,
    [ COMPARISON_OPERATOR.LESS_THAN_OR_EQUAL ]:    COMPARISON_SYMBOL.LESS_THAN_OR_EQUAL,
    [ COMPARISON_OPERATOR.IN ]:                    COMPARISON_SYMBOL.IN,
    [ COMPARISON_OPERATOR.NOT_IN ]:                COMPARISON_SYMBOL.NOT_IN,
    [ COMPARISON_OPERATOR.LIKE ]:                  COMPARISON_SYMBOL.LIKE,
    [ COMPARISON_OPERATOR.IS ]:                    COMPARISON_SYMBOL.IS,
    [ COMPARISON_OPERATOR.IS_NOT ]:                COMPARISON_SYMBOL.IS_NOT
} as const;

export const NEGATE_COMPARISON_OPERATOR = new Set([
    COMPARISON_OPERATOR.NOT_IN
]);
